module.exports = __webpack_public_path__ + "assets/navetta.d0942861.svg";